import Vue from 'vue';
import Vuex from 'vuex';

Vue.use(Vuex);

const debug = process.env.NODE_ENV !== 'production';

export default new Vuex.Store({
   state: {
      ui: {
         userMenuVisible: false,
         contactFormVisible: false
      },
      DEBUG: true
   },
   getters: {
   },
   mutations: {
      // User menu mutations (app wide)
      toggleUserMenu: (state) => {
         state.ui.userMenuVisible = !state.ui.userMenuVisible;
      },
      hideUserMenu: (state) => {
         state.ui.userMenuVisible = false;
      },
      // Contact Form
      showContactForm: (state) => {
         state.ui.contactFormVisible = true;
      },
      hideContactForm: (state) => {
         state.ui.contactFormVisible = false;
      }
   },
   strict: debug,
});


// WEBPACK FOOTER //
// ./src/store/index.js